import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

/* Global Declerations */
// plugins
import './plugins'
/* Filters */
import './filters'
/* Components */
import churchIcon  from '@/components/churchappIcons'
import knowledgeItem from './components/resourceItem.vue'


Vue.component('church-icon', churchIcon)
Vue.component('m-resource-item', knowledgeItem)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


/* remove console in production */
console.log(process.env.NODE_ENV)

if(process.env.NODE_ENV != 'development') {
  console.log = () => {}
}